import ImagePopup from '@/components/popup/imagePopup.vue';
var popup = null;
/**
 * 获取一个popup
 */

export function getImagePopup(options) {
  if (popup) {
    return popup;
  }

  popup = new ImagePopup({
    el: document.createElement('div'),
    propsData: {
      src: options.src,
      imageClass: options.imageClass
    }
  });
  document.body.appendChild(popup.$el);
  return popup;
}
export function showImagePopup(options) {
  var popup = getImagePopup(options);
  popup.src = options.src;
  popup.imageClass = options.imageClass;
  popup.value = true;
  return function () {
    popup.value = false;
  };
}